/**
 * @deprecated CarouselWIP is deprecated and will be removed in the next major version. Please migrate to Carousel which now supports all CarouselWIP features.
 */
export { CarouselWIP } from './CarouselWIP';

/**
 * @deprecated CarouselWIP is deprecated and will be removed in the next major version. Please migrate to Carousel which now supports all CarouselWIP features.
 */
export type { CarouselWIPProps, CarouselWIPImage } from './CarouselWIP.types';
